import { useState } from "react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { CaretLeft, CaretRight, CalendarBlank } from "@phosphor-icons/react";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const formatMonthYear = (v) => {
  const m = String(v || "").match(/^(\d{4})-(\d{2})/);
  return m ? `${m[2]}/${m[1]}` : (v || "");
};

export function MonthYearPicker({ value, onChange, className, testid }) {
  const parsed = String(value || "").match(/^(\d{4})-(\d{2})/);
  const [open, setOpen] = useState(false);
  const [year, setYear] = useState(parsed ? Number(parsed[1]) : new Date().getFullYear());
  const pick = (i) => { onChange(`${year}-${String(i + 1).padStart(2, "0")}`); setOpen(false); };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} className={`${className} flex items-center justify-between text-left`}>
          <span className={value ? "" : "text-slate-500"}>{value ? formatMonthYear(value) : "MM/YYYY"}</span>
          <CalendarBlank size={16} className="text-slate-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-64 bg-[#0A1120] border-[#1E293B] text-white p-3" data-testid={`${testid}-popover`}>
        <div className="flex items-center justify-between mb-3">
          <button type="button" onClick={() => setYear(y => y - 1)} data-testid={`${testid}-prev-year`} className="p-1 hover:text-[#D4AF37]"><CaretLeft size={16} /></button>
          <span className="font-semibold" data-testid={`${testid}-year`}>{year}</span>
          <button type="button" onClick={() => setYear(y => y + 1)} data-testid={`${testid}-next-year`} className="p-1 hover:text-[#D4AF37]"><CaretRight size={16} /></button>
        </div>
        <div className="grid grid-cols-3 gap-2">
          {MONTHS.map((m, i) => {
            const active = parsed && Number(parsed[1]) === year && Number(parsed[2]) === i + 1;
            return (
              <button type="button" key={m} onClick={() => pick(i)} data-testid={`${testid}-month-${i + 1}`}
                className={`py-1.5 rounded-md text-sm border ${active ? "bg-[#D4AF37] text-[#060B14] border-[#D4AF37]" : "border-[#1E293B] hover:border-[#D4AF37]/50"}`}>
                {m}
              </button>
            );
          })}
        </div>
        {value && <button type="button" onClick={() => { onChange(""); setOpen(false); }} className="mt-3 text-xs text-slate-400 hover:text-white">Clear</button>}
      </PopoverContent>
    </Popover>
  );
}
